// @generated
// AUTO-GENERATED by scripts/generate-fhir-terminologies.ts. Do not edit.
// Run: npm run generate:terminologies
// Source: apps/ig/input/resources/value-sets/marital-statuses.json
export const URL = 'http://alopexcare.com/fhir/ValueSet/marital-statuses';
export const concepts = [
    { code: 'A', display: 'Annulled', displayUi: 'Annulled', system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus' },
    { code: 'D', display: 'Divorced', displayUi: 'Divorced', system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus' },
    { code: 'I', display: 'Interlocutory', displayUi: 'Interlocutory', system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus' },
    { code: 'L', display: 'Legally Separated', displayUi: 'Legally Separated', system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus' },
    { code: 'M', display: 'Married', displayUi: 'Married', system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus' },
    { code: 'P', display: 'Polygamous', displayUi: 'Polygamous', system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus' },
    { code: 'S', display: 'Never Married', displayUi: 'Never Married', system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus' },
    { code: 'T', display: 'Domestic Partner', displayUi: 'Domestic Partner', system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus' },
    { code: 'U', display: 'Unmarried', displayUi: 'Unmarried', system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus' },
    { code: 'W', display: 'Widowed', displayUi: 'Widowed', system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus' },
    { code: 'UNK', display: 'Unknown', displayUi: 'Unknown', system: 'http://terminology.hl7.org/CodeSystem/v3-NullFlavor' },
];
export function isValidCode(value) {
    return concepts.some((c) => c.code === value);
}
/** Returns the UI display (designation override if present, else canonical display). */
export function getDisplay(code) {
    return concepts.find((c) => c.code === code)?.displayUi ?? '';
}
/**
 * Build a FHIR Coding with the canonical display (NOT displayUi) to preserve
 * server-side terminology-binding validity. Use getDisplay() for UI rendering.
 */
export function toCoding(code) {
    const concept = concepts.find((c) => c.code === code);
    return { system: concept?.system ?? '', code, display: concept?.display ?? '' };
}
